import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';
import { RegisterDataType, RegisterFinishDataType } from '../types/Auth';

interface RegisterState {
  registerData: RegisterDataType
  setRegisterData:(data:RegisterDataType ) => void
  
}

interface RegisterFinishState {
  registerFinishData: RegisterFinishDataType
  setRegisterFinishData: (data: RegisterFinishDataType) => void
}

export const useRegisterStore = create(
  persist<RegisterState>(
    (set, get) => ({

       registerData: {
        clientCode: '',
        cpfCnpj: ''
       },

       setRegisterData: (registerData: RegisterDataType) => set(() => ({registerData})),
    }),
    {
      name: 'register_store', 
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);

export const useRegisterFinishStore = create(
  persist<RegisterFinishState>(
    (set, get) => ({
      registerFinishData: {
        clientCode: '',
        cpfCnpj: '',
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        confirmEmail: '',
        notificationCheck: false,
      },
      setRegisterFinishData: (registerFinishData: RegisterFinishDataType) => set(() => ({ registerFinishData })),
    }),
    {
      name: 'registerFinish_store',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
